module.exports = __webpack_public_path__ + "img/gas-disabled.dc71f7f8.png";